import axios from '@/service/axios'

// 搜索
export function getSearchResult(params) {
    return axios.post(`/case/search`,params)
}

